import {
  Carousel,
  CarouselContent,
  CarouselIndicator,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";

export const CardSlider = ({ items }: { items: React.ReactNode[] }) => {
  return (
    <Carousel>
      <CarouselContent>
        {items.map((item, index) => {
          return (
            <CarouselItem
              key={index}
              className="basis-full md:basis-1/2 lg:basis-1/3 md:pl-0 md:pr-7"
            >
              <div className="h-full">{item}</div>
            </CarouselItem>
          );
        })}
      </CarouselContent>
      <div className="mt-12 flex items-center justify-between w-full">
        <CarouselIndicator variant="gray" alignment="left" size="small" />
        <div className="flex gap-4">
          <CarouselPrevious className="static m-0 translate-y-0 rounded-sm" />
          <CarouselNext className="static m-0 translate-y-0 rounded-sm" />
        </div>
      </div>
    </Carousel>
  );
};
